<template>
<div class="aaSginUpAdd">
    <div v-if="init">
    <div class="info">
        <div class="name"><span>姓名</span><span class="red">*</span></div>
        <van-field v-model="item.joinername" type="text" clearable placeholder="请填写您的姓名" maxlength="6" />
    </div>
    <div class="info">
        <div class="name"><span>手机</span><span class="red">*</span></div>
        <van-field v-model="item.joinermobile" type="tel" clearable placeholder="请填写您的手机号码" maxlength="11" />
    </div>
    <div v-for="(obj,index) in collist" :key="index">
        <div class="info" v-if="obj.coltype==1">
            <div class="name"><span>{{obj.colname}}</span><span class="red" v-if="obj.isnotnull">*</span></div>
            <van-field v-model="obj.colvalue" type="text" clearable :placeholder="obj.placeholder" />
        </div>
        <div class="info" v-if="obj.coltype==5">
            <div class="name"><span>{{obj.colname}}</span><span class="red" v-if="obj.isnotnull">*</span></div>
            <van-field v-model="obj.colvalue" type="textarea" rows="4" maxlength="200" show-word-limit autosize :placeholder="obj.placeholder" />
        </div>
        <div class="info" v-if="obj.coltype==3">
            <div class="name"><span>{{obj.colname}}</span><span class="red" v-if="obj.isnotnull">*</span></div>
            <van-field v-model="obj.colvalue" type="text" clearable :placeholder="obj.placeholder" @click="setDate" disabled />
            <van-popup v-model="show" position="bottom">
                <van-datetime-picker v-model="date" :max-date="maxDate" :min-date="minDate" type="date"
                                     @confirm="confirm(obj)" @cancel="cancel"/>
            </van-popup>
        </div>
        <div class="info" v-if="obj.coltype==8">
            <div class="name"><span>{{obj.colname}}</span></div>
            <van-dropdown-menu active-color="#0ABF53">
                <van-dropdown-item v-model="obj.colvalue" :options="obj.optionsinfo" />
            </van-dropdown-menu>
        </div>
        <div class="info" v-if="obj.coltype==6">
            <div class="name"><span>{{obj.colname}}</span></div>
            <van-radio-group v-model="obj.colvalue">
                <van-radio :name="radio" checked-color="#0ABF53" v-for="(radio,index) in obj.optionsinfo" :key="index">{{radio}}</van-radio>
            </van-radio-group>
        </div>
        <div class="info" v-if="obj.coltype==7">
            <div class="name"><span>{{obj.colname}}</span></div>
            <van-checkbox-group v-model="obj.colvalue">
                <van-checkbox :name="checkbox" v-for="(checkbox,index) in obj.optionsinfo" :key="index" shape="square" checked-color="#0ABF53">{{checkbox}}</van-checkbox>
            </van-checkbox-group>
        </div>
    </div>
    <div class="signadd-btn">
        <div class="btn cancel" @click="cancelBack">取消</div>
        <div class="btn ok" @click="submitUser">确定</div>
    </div>
    </div>
</div>
</template>

<script>
import {getEventFormInfo, getEventTicketUserInfo, saveOrUpdateEventTicketUser} from 'api/activeTools'
import {saveShareTicketForGet} from 'api/activeTools'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'aaSginUpAdd',
    data() {
        return {
            param: {
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                joininerid: this.$route.query.joininerid ? this.$route.query.joininerid : ''
            },
            item: {
                joinername: '',
                joinermobile: '',
                datajson: []
            },
            collist: [
                // colinnerid:表单innerid;
                // colname:字段名称
                // placeholder:字段提示语
                // optionsinfo:下拉，单选，多选类型的选项表，多个以逗号分隔
                // isnotnull:是否必填 0否 1是
                // colindex:显示序号
                // coltypename:字段类型文本信息
                // coltype:字段类型 1单行文本框 3日期选择框 5多行文本框 6单选按钮框 7多选按钮框 8下拉选择框
            ],
            date: new Date(1990, 1, 1),
            minDate: new Date(1960, 1, 1),
            maxDate: new Date(),
            show: false,
            init: false,
            isGetTicketFrom: false,
            shareid: this.$route.query.shareid ? this.$route.query.shareid : ''
        }
    },
    mounted() {
        // if (!this.isInit) {
        //     if (this.param.joininerid) {
        //         this._getUserInfo()
        //     } else {
        //         this._getSetting()
        //     }
        // }
        this._getSetting()
    },
    activated() {
        if (this.isInit) {
            this.param.eventid = this.$route.query.eventid
            this.param.joininerid = this.$route.query.joininerid
            this.item = {
                joinername: '',
                joinermobile: '',
                datajson: []
            }
            if (this.param.joininerid) {
                this._getUserInfo()
            } else {
                this._getSetting()
            }
        }
        this.setIsInit(false)
    },
    // 判断是否是领取票券过来的
    beforeRouteEnter (to, from, next) {
        if (from.name === 'getTicket') {
            next((v) => {
                v.isGetTicketFrom = true
            })
        } else {
            next((v) => {
                if (v.shareid) {
                    v.isGetTicketFrom = true
                }
            })
        }
    },
    methods: {
        setDate() {
            this.show = true
        },
        confirm(obj) {
            obj.colvalue = (this.date.getFullYear()) + '-' + (this.date.getMonth() + 1) + '-' + (this.date.getDate())
            this.cancel()
        },
        cancel() {
            this.show = false
        },
        cancelBack() {
            this.$router.back()
        },
        submitUser() {
            let tmpList = []
            let flag = true
            if (!this.item.joinername) {
                this.$toast.fail('请输入6位姓名')
                flag = false
                return false
            }
            if (!this.item.joinermobile || !/^1\d{10}$/.test(this.item.joinermobile)) {
                this.$toast.fail('请输入11位正确的手机号码')
                flag = false
                return false
            }
            this.collist.forEach((obj) => {
                let colvalue = []
                if (obj.coltype === 7) {
                    let arr = obj.colvalue.filter(obj => obj)
                    colvalue = arr.join(',')
                } else {
                    colvalue = obj.colvalue
                }
                if (obj.isnotnull && !obj.colvalue) {
                    flag = false
                    this.$toast.fail('请输入/选择' + obj.colname)
                    return false
                }
                tmpList.push({colinnerid: obj.colinnerid, colvalue: colvalue})
            })
            if (flag) {
                this.item.datajson = JSON.stringify(tmpList)
                this._editUser()
            }
        },
        _editUser() {
            saveOrUpdateEventTicketUser({
                data: Object.assign({}, this.param, this.item),
                success: data => {
                    this.$toast.success('保存成功')
                    if (!this.isGetTicketFrom) {
                        this.setInitAaEnrollment(true)
                        this.cancelBack()
                    } else { // 领取票券
                        this.saveShareTicketForGet(data.data.joininerid)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 领取票券
        saveShareTicketForGet(ticketuserid) {
            if (this.param.eventid && this.shareid) {
                this.setLoading(true)
                saveShareTicketForGet({
                    data: {eventid: this.param.eventid, shareid: this.shareid, ticketuserid},
                    success: () => {
                        this.setLoading(false)
                        this.$toast.success('领取成功')
                        this.$router.push({name: 'myTicket', query: {eventid: this.param.eventid}})
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$toast.fail(data.msg)
                    }
                })
            }
        },
        _getUserInfo() {
            getEventTicketUserInfo({
                data: this.param,
                success: data => {
                    this.item.joinername = data.data.joinername
                    this.item.joinermobile = data.data.joinermobile
                    // this.collist = this._formarSetting(data.data.collist)
                    this.collist.forEach(obj => {
                        data.data.collist.forEach(obj2 => {
                            if (obj.colinnerid === obj2.colinnerid) {
                                if (obj2.coltype === 7) {
                                    obj.colvalue = obj2.colvalue ? obj2.colvalue.split(',') : []
                                } else {
                                    obj.colvalue = obj2.colvalue
                                }
                            }
                        })
                    })
                    this.init = true
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        _getSetting() {
            getEventFormInfo({
                data: this.param,
                success: data => {
                    this.collist = this._formarSetting(data.data.collist)
                    if (this.param.joininerid) {
                        this._getUserInfo()
                    } else {
                        this.init = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        _formarSetting(collist) {
            collist.forEach(obj => {
                if (obj.coltype === 8) {
                    let optionsinfo = [{text: '请选择', value: ''}]
                    obj.optionsinfo = obj.optionsinfo ? obj.optionsinfo.split(',') : []
                    obj.optionsinfo.forEach(obj2 => {
                        optionsinfo.push({text: obj2, value: obj2})
                    })
                    obj.optionsinfo = optionsinfo
                } else if (obj.coltype === 6) {
                    obj.optionsinfo = obj.optionsinfo ? obj.optionsinfo.split(',') : []
                } else if (obj.coltype === 7) {
                    obj.optionsinfo = obj.optionsinfo ? obj.optionsinfo.split(',') : []
                    obj.colvalue = obj.colvalue ? obj.colvalue.split(',') : []
                }
            })
            return collist
        },
        ...mapActions([
            'setLoading',
            'setInitAaEnrollment',
            'setIsInit'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'isInit'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.aaSginUpAdd {
    padding-bottom: 1.1rem;
    background: #fff;
    .info{
        padding: 0.32rem;
        font-size: 0.3rem;
        .name{
            color:  #333333 ;
            margin-bottom: 0.28rem;
            .red{
                color:  #FF4747 ;
            }
        }
        .van-field{
            padding: 0
        }
        textarea{
            padding: 0.16rem;
            background: #F5F5F5;
        }
    }
    .van-picker__toolbar{
        @include flexBox(space-between);
    }
    .van-picker-column{
        margin-top: 0.28rem;
    }
    .van-dropdown-menu__item{
        .van-dropdown-menu__title{
            width: 100%;
            @include flexBox(space-between);
            padding:0;
            &:after{
                right: 0.1rem;
                width: 0.16rem;
                height: 0.16rem;
                border-left: 0.02rem solid #999;
                border-bottom: 0.02rem solid #999;
                transform: translate(0,-50%) rotate(-135deg);
            }
        }
        .van-dropdown-menu__title--down::after{
            border-left: 0.02rem solid #0ABF53;
            border-bottom: 0.02rem solid #0ABF53;
            top: 0.06rem;
            transform: translate(0,-50%) rotate(-45deg);
        }
    }
    .van-dropdown-menu.van-hairline--top-bottom::after{
        border-width: 0;
    }
    .van-radio{
        .van-radio__label{
            margin-left: 0.6rem;
        }
        .van-radio__icon .van-icon{
            border-color: #0ABF53;
        }
    }
    .van-radio+.van-radio{
        margin-top: 0.4rem;
    }
    .van-checkbox{
        .van-checkbox__icon .van-icon{
            border-color: #0ABF53;
        }
        .van-checkbox__label{
            margin-left: 0.6rem;
        }
    }
    .van-checkbox+.van-checkbox{
        margin-top: 0.4rem;
    }
    .van-cell:not(:last-child)::after{
        border-width: 0;
    }
    .signadd-btn{
        position: fixed;
        bottom: 0;
        left:0;
        right:0;
        height: 1.1rem;
        @include flexBox(space-between);
        background:#fff;
        box-shadow:2px 0px 4px 0px rgba(0,0,0,0.1);
        padding: 0 0.32rem;
        .btn{
            /*margin-top: 0.01rem;*/
            width: 3.27rem;
            height: 0.78rem;
            line-height: 0.78rem;
            text-align: center;
            border-radius:0.4rem;
            font-size: 0.32rem;
            box-sizing: border-box;
        }
        .cancel{
            color: #0ABF53;
            border: 0.01rem solid #0ABF53;
        }
        .ok{
            color: #fff;
            background:linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
        }
    }
}
</style>
